<template>
  <div>
    <el-form ref="form" :model="defaultForm" label-width="80px">
      <el-form-item>
        <el-radio v-model="radio" label="1">{{ currentType }}</el-radio>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="courseId"
          :placeholder="'请选择' + currentType + '类型课评'"
          @change="handleChangeSelect"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-row :gutter="20" v-if="defaultForm.imageConfig">
        <el-col :span="12">
          <el-form-item label="上传照片">
            <el-radio-group v-model="defaultForm.imageConfig.enable">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="张数" v-if="defaultForm.imageConfig.enable">
            <el-input
              v-model="defaultForm.imageConfig.maxNumber"
              type="number"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="defaultForm.videoConfig">
        <el-col :span="12">
          <el-form-item label="上传视频">
            <el-radio-group v-model="defaultForm.videoConfig.enable">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="个数" v-if="defaultForm.videoConfig.enable">
            <el-input
              v-model="defaultForm.videoConfig.maxNumber"
              type="number"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="金币">
        <el-radio-group v-model="defaultForm.goldEnable">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="录音">
        <el-radio-group v-model="defaultForm.audioEnable">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-for="(item, index) in defaultForm.dimensions" :key="index">
        <el-row :gutter="20">
          <el-form-item :label="index == 0 ? '维度' : ''">
            <el-col :span="8">
              <el-input
                :disabled="
                  (index == 0 || index == 1) && currentType == 'A'
                    ? true
                    : false
                "
                v-model="item.name"
                placeholder="请输入名称"
              ></el-input>
            </el-col>
            <!-- <el-col :span="8">
              <el-input
                :disabled="
                  (index == 0 || index == 1) && currentType == 'A'
                    ? true
                    : false
                "
                v-model="item.field"
                placeholder="请输入数据形式"
              ></el-input>
            </el-col> -->
            <el-col :span="8">
              <el-select v-model="item.type" placeholder="请选择">
                <el-option
                  v-for="item in optionsType"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <i
                v-if="defaultForm.dimensions.length - 1 == index"
                @click="handleAdd"
                style="font-size: 24px"
                class="el-icon-circle-plus-outline"
              ></i>
              <i
                v-if="
                  defaultForm.dimensions.length > 1 && index != 0 && index != 1
                "
                @click="handleDelete(index)"
                style="font-size: 24px"
                class="el-icon-circle-close"
              ></i>
            </el-col>
          </el-form-item>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getConfigData } from "@/api/AfterClassService";

export default {
  props: {
    currentType: {
      default: "A",
      type: String,
    },
    options: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      radio: "1",
      courseId: null,
      defaultForm: {
        imageConfig: {
          enable: false,
        },
        videoConfig: {
          enable: false,
        },
        audioEnable: false,
        goldEnable: false,
        dimensions: [],
      },
      optionsType: [
        {
          text: "数值类型",
          id: 1,
        },
        {
          text: "文本类型",
          id: 2,
        },
      ],
    };
  },
  mounted() {
    let defaultTypeData = [];
    console.log(this.currentType, "当前类型");
    if (this.currentType == "A") {
      defaultTypeData = [
        {
          name: "身高",
          field: "height",
          type: 1,
        },
        {
          name: "体重",
          field: "weight",
          type: 1,
        },
      ];
      this.$set(this.defaultForm, "dimensions", defaultTypeData);
    } else {
      defaultTypeData = [
        {
          name: "",
          field: "",
        },
      ];
      this.$set(this.defaultForm, "dimensions", defaultTypeData);
    }
  },
  methods: {
    handleChangeSelect(e) {
      console.log(e, "下拉");
      this.getConfigItem(e);
    },
    // 查询课程配置
    getConfigItem(courseId) {
      getConfigData({ id: courseId }).then((response) => {
        console.log("配置", response);
        this.defaultForm = response.data;
        // this.defaultForm = {
        //   ...response.data,
        //   courseId:this.courseId
        // };
        if (this.defaultForm.dimensions.length == 0) {
          if (this.currentType == "A") {
            this.defaultForm.dimensions.push(
              {
                name: "身高",
                field: "height",
                type: 1,
              },
              {
                name: "体重",
                field: "weight",
                type: 1,
              }
            );
          } else {
            this.defaultForm.dimensions.push({
              name: "",
              field: "",
            });
          }
        }
      });
    },
    handleAdd() {
      this.defaultForm.dimensions.push({
        name: "",
        field: "",
      });
    },
    handleDelete(index) {
      this.defaultForm.dimensions.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/service/course-evaluation-A/components/params-setting.vue